import { forwardRef } from 'react';
import cx from 'classnames';
import { renderDesignTokens, useDesignTokens } from '../../theme';
import { postfixTestId } from '../../util/testId';
import { BusyStateIndicator } from '../BusyStateIndicator';
import { Button } from '../Button';
import { Heading } from '../Heading';
import { Flow } from '../Layouts/Flow';
import { SVG } from '../SVG';
import { Text } from '../Text';
import cn from './ZeroState.css.json';
import './ZeroState.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ZeroState = /*#__PURE__*/forwardRef(function (props, ref) {
  const {
    text,
    heading,
    icon,
    disabled,
    tokens: zsTokens,
    busyStateIndicatorProps,
    theme,
    headingLevel,
    removeRole
  } = props;
  const dt = useDesignTokens();
  const tokens = {
    ...getZeroStateDesignTokens(dt, {
      disabled,
      tokens: zsTokens,
      busyStateActive: busyStateIndicatorProps?.active ?? false
    }),
    ...theme?.(dt)
  };
  return /*#__PURE__*/_jsxs("div", {
    role: removeRole ? undefined : 'group',
    "aria-label": removeRole ? undefined : props.ariaLabel,
    "aria-labelledby": removeRole ? undefined : props.ariaLabelledBy,
    "data-testid": props.testId,
    className: cx(cn.zeroState, props.className, props.alignTop && cn.alignTop),
    style: {
      ...tokens,
      ...props.style
    },
    children: [icon ? /*#__PURE__*/_jsx(SVG, {
      style: {
        order: '1'
      },
      icon: icon,
      type: "zerostate",
      testId: postfixTestId(props.testId, 'icon'),
      disabled: disabled
    }) : null, heading ? /*#__PURE__*/_jsx(Heading, {
      style: {
        order: '3'
      },
      wrapText: true,
      "aria-hidden": "true",
      level: headingLevel ?? 5,
      className: cn.heading,
      testId: postfixTestId(props.testId, 'heading'),
      disabled: disabled,
      children: heading
    }) : null, text ? /*#__PURE__*/_jsx(Text, {
      style: {
        order: '4'
      },
      ref: ref,
      className: cn.text,
      focusable: true,
      ariaLabel: heading ? `${heading} ${text}` : undefined,
      testId: postfixTestId(props.testId, 'text'),
      disabled: disabled,
      children: text
    }) : null, props.actionButtonOneProps ? /*#__PURE__*/_jsxs(Flow, {
      style: {
        order: '5'
      },
      wrap: true,
      spacing: "s",
      className: cn.buttonGroup,
      "data-testid": postfixTestId(props.testId, 'flow'),
      children: [props.actionButtonOneProps ? /*#__PURE__*/_jsx(Button, {
        ...props.actionButtonOneProps,
        disabled: disabled ?? props.actionButtonOneProps.disabled
      }) : null, props.actionButtonTwoProps ? /*#__PURE__*/_jsx(Button, {
        ...props.actionButtonTwoProps,
        disabled: disabled ?? props.actionButtonTwoProps.disabled
      }) : null, props.actionButtonThreeProps ? /*#__PURE__*/_jsx(Button, {
        ...props.actionButtonThreeProps,
        disabled: disabled ?? props.actionButtonThreeProps.disabled
      }) : null]
    }) : null, busyStateIndicatorProps ? /*#__PURE__*/_jsx(BusyStateIndicator, {
      style: {
        order: '2'
      },
      ...busyStateIndicatorProps
    }) : null]
  });
});
export const getZeroStateDesignTokens = (dt, opts) => {
  return renderDesignTokens({
    'mg-s': dt.tokens['space-base-s'],
    'font-weight-thick': dt.tokens['font-style-weight-700'],
    'heading-font-size': opts?.tokens?.heading?.fontSize ?? dt.tokens['font-size-heading-text-5'],
    'heading-fg': opts?.disabled ? opts?.tokens?.heading?.color ?? dt.tokens['color-action-text-standard-disabled'] : opts?.tokens?.heading?.color ?? dt.tokens['color-heading-text'],
    'text-font-size': opts?.tokens?.text?.fontSize ?? dt.tokens['font-size-body-text-m'],
    'text-fg': opts?.disabled ? opts?.tokens?.text?.color ?? dt.tokens['color-action-text-standard-disabled'] : opts?.tokens?.text?.color ?? dt.tokens['color-body-text'],
    'text-space': opts?.busyStateActive ? dt.tokens['space-base-s'] : dt.tokens['space-base-null']
  }, 'zero-state');
};
//# sourceMappingURL=ZeroState.js.map